webpackJsonp([44],{

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(52)(
  /* script */
  __webpack_require__(762),
  /* template */
  __webpack_require__(825),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 762:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_handy__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_handy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(98);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // common
      sbar: false,
      sbarMsg: '',
      sbarCol: 'info',
      handy: __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a,
      config: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a,
      beingSaved: false,
      // notice board
      notices: [],
      totNotice: 0,
      dlgNotice: false,
      // post
      posts: [],
      show: false,
      // admins
      joinReq: [],
      // invoice
      invoices: '',
      tasks: '',
      // complaints
      totMine: 0,
      totOpenComp: 0,
      totNewComp: 0,
      totCritComp: 0,
      totPersComp: 0,
      // visitors
      visitorList: [],
      visitCatIcon: {
        'Guest': 'face',
        'Daily Helper': 'people',
        'Delivery': 'shopping_cart',
        'Cab': 'directions_car',
        'Vendor': 'build'
      },
      // fm
      statDay: 'today',
      attend: '',
      dailyUpdate: '',
      assets: '',
      incidents: '',
      totalLikes: [],
      totalPinned: [],
      totalComment: [],
      showDateList: false,
      dateHeader: [{ text: 'Dates', values: 'selected_date' }],
      dlgHowToResDir: false,
      dlgHowToSecGaurd: false,
      dlgHowToiPhone: false,
      commSetupScore: { subscription: {}, setup_score: {} },
      isCommSetupPend: false,
      isMobAdminUser: true,
      dlgCommSetup: false
    };
  },

  computed: {
    today: function today() {
      return __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDBDate(Date());
    },
    nextThreeDays: function nextThreeDays() {
      var curDt = new Date();
      curDt.setDate(curDt.getDate() + 3);
      return __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDBDate(curDt);
    },
    totDlgNotice: function totDlgNotice() {
      if (this.notices.length) {
        this.dlgNotice = true;
      } else {
        this.dlgNotice = false;
      }
      return this.notices.length;
    }
  },
  created: function created() {
    this.refreshDashboard();
  },

  watch: {
    '$route': function $route(to, from) {
      this.refreshDashboard();
      this.$forceUpdate();
    }
  },
  methods: {
    msg: function msg(m) {
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.sbarCol = isError ? 'error' : 'success';
      this.sbar = true;
      this.sbarMsg = m;
    },
    refreshDashboard: function refreshDashboard() {
      // note: all these methods are asyncronous and will be loaded independantly
      if (__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.IS_ADMIN) {
        this.loadCommSetupScore();
      } else {
        this.isCommSetupPend = false;
      }
      this.loadIsMobAdminUser();
      if (__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.UNIT_ID_LIST.length || __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.IS_ADMIN) {
        this.loadJoinReq();
      }
      if (!__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.IS_OTHER_USER) {
        this.loadInvoices();
      }
      this.loadComps();
      this.loadVisitors();
      this.loadNotices();
      this.loadPosts();
      this.loadTasks();
      if (__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.IS_OTHER_USER) {
        this.loadStatsForStaffDashboard();
      }
    },
    cancelReq: function cancelReq(curUnit) {
      var _this = this;

      if (confirm('Sure, you want to cancel the request?')) {
        var req = {
          unit_id: curUnit.unit_id,
          cust_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.CUST_ID,
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          is_other_user: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.IS_OTHER_USER
        };
        this.axios.post(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/admin/cancel-req', req).then(function (response) {
          // refresh list in front end
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["c" /* logout */])();
        }).catch(function (err) {
          _this.msg(err.response.data, true);
        });
      }
    },
    logout: function logout() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["c" /* logout */])();
    },
    loadTasks: function loadTasks() {
      var _this2 = this;

      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getOpenTaskSummaryByUserId/', qry).then(function (response) {
        _this2.tasks = response.data[0];
      });
    },
    loadInvoices: function loadInvoices() {
      var _this3 = this;

      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          cust_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.CUST_ID,
          unit_id_list: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.UNIT_ID_LIST,
          include_detail: true
        }
      };
      this.invoices = '';
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getAccBalByCustId/', qry).then(function (response) {
        if (response.data.length) {
          _this3.invoices = {};
          _this3.invoices.tot_due = Number(response.data.map(function (rec) {
            return rec.pending_amount;
          }).reduce(function (a, b) {
            return Number(a || 0) + Number(b || 0);
          }, 0));
          _this3.invoices.past_due = Number(response.data.filter(function (rec) {
            return !rec.due_dt || __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDBDate(rec.due_dt) < _this3.today;
          }).map(function (rec) {
            return rec.pending_amount;
          }).reduce(function (a, b) {
            return Number(a || 0) + Number(b || 0);
          }, 0));
          _this3.invoices.due_today = Number(response.data.filter(function (rec) {
            return __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDBDate(rec.due_dt) === _this3.today;
          }).map(function (rec) {
            return rec.pending_amount;
          }).reduce(function (a, b) {
            return Number(a || 0) + Number(b || 0);
          }, 0));
        }
      });
    },
    loadNotices: function loadNotices() {
      var _this4 = this;

      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getNoticesByCommId/', qry).then(function (response) {
        _this4.totNotice = response.data.length;
        _this4.notices = response.data.filter(function (rec) {
          return !rec.is_ack;
        });
      });
    },
    ackNotice: function ackNotice(isAck) {
      var _this5 = this;

      // update db if acknowledged
      if (isAck) {
        this.beingSaved = true;
        this.axios.post(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/notice/ack', { 'notice_id': this.notices[this.totDlgNotice - 1].notice_id, 'user_id': __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID, 'comm_id': __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID }).then(function (response) {
          _this5.beingSaved = false;
        }).catch(function (err) {
          _this5.msg(err.response.data, true);
          _this5.beingSaved = false;
        });
      }
      // pop out
      this.notices.splice(this.totDlgNotice - 1, 1);
    },
    loadPosts: function loadPosts() {
      var _this6 = this;

      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getTrendingPost/', qry).then(function (response) {
        _this6.posts = response.data;
      });
    },
    loadComps: function loadComps() {
      var _this7 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID
        }
        // users complaints (created by / assigned to this user)
      };this.totMine = 0;
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getComplaintsByUser/', qry).then(function (response) {
        _this7.totMine = response.data.length;
      });
      // all open complaints
      this.totOpenComp = 0;
      this.totNewComp = 0;
      this.totCritComp = 0;
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getComplaintsByComm/', qry).then(function (response) {
        _this7.totOpenComp = response.data.length;
        _this7.totNewComp = response.data.filter(function (rec) {
          return rec.comp_status === 'New';
        }).length;
        _this7.totCritComp = response.data.filter(function (rec) {
          return rec.comp_severity === 'Critical';
        }).length;
      });
    },
    loadCommSetupScore: function loadCommSetupScore() {
      var _this8 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getCommSetupCompScore/', qry).then(function (response) {
        _this8.commSetupScore = response.data;
        _this8.isCommSetupPend = _this8.commSetupScore.setup_score.corScore <= _this8.commSetupScore.setup_score.corScoreBase && _this8.commSetupScore.subscription.collab_module; // only FM clients
        _this8.isCommSetupPend = _this8.isCommSetupPend || _this8.commSetupScore.subscription.visitor_module && _this8.commSetupScore.setup_score.vmScore <= _this8.commSetupScore.setup_score.vmScoreBase;
        _this8.isCommSetupPend = _this8.isCommSetupPend || _this8.commSetupScore.subscription.accounts_module && _this8.commSetupScore.setup_score.acScore <= _this8.commSetupScore.setup_score.acScoreBase;
        _this8.isCommSetupPend = _this8.isCommSetupPend || _this8.commSetupScore.subscription.facility_module && _this8.commSetupScore.setup_score.fmScore <= _this8.commSetupScore.setup_score.fmScoreBase;
        _this8.$forceUpdate();
      }).catch(function (err) {
        _this8.msg(err.response.data, true);
      });
    },
    loadIsMobAdminUser: function loadIsMobAdminUser() {
      var _this9 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID
        }
        // load joining request of new user for the particular community
      };this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getIsMobileAdminUser/', qry).then(function (response) {
        _this9.isMobAdminUser = response.data.length;
      }).catch(function (err) {
        _this9.msg(err.response.data, true);
      });
    },
    loadJoinReq: function loadJoinReq() {
      var _this10 = this;

      var qry = {
        params: {
          unit_id_list: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.UNIT_ID_LIST,
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          is_admin: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.IS_ADMIN,
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID
        }
        // load joining request of new user for the particular community
      };this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getJoiningRequest/', qry).then(function (response) {
        _this10.joinReq = response.data;
      }).catch(function (err) {
        _this10.msg(err.response.data, true);
        _this10.joinReq = [];
      });
    },
    loadVisitors: function loadVisitors() {
      var _this11 = this;

      // load today's visitors
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          unit_id_list: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.IS_OTHER_USER ? '' : __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.PRIVATE_UNIT_ID_LIST,
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID,
          from_dt: this.today,
          to_dt: this.today
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getMyVisitorByPeriodAndStatus/', qry).then(function (response) {
        _this11.visitorList = response.data;
      });
    },
    loadStatsForStaffDashboard: function loadStatsForStaffDashboard() {
      var _this12 = this;

      var statDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.statDay;

      this.statDay = statDay;
      var statDate = this.today;
      if (statDay === 'yesterday') {
        var curDate = new Date();
        statDate = __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDBDate(curDate.setDate(curDate.getDate() - 1));
      }
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID,
          stat_dt: statDate
        }
        // all open complaints
      };this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getComplaintsByComm/', qry).then(function (response) {
        _this12.totOpenComp = response.data.length;
        _this12.totNewComp = response.data.filter(function (rec) {
          return rec.comp_status === 'New';
        }).length;
        _this12.totCritComp = response.data.filter(function (rec) {
          return rec.comp_severity === 'Critical';
        }).length;
      });
      // attendace
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getAttendanceStat/', qry).then(function (response) {
        _this12.attend = response.data;
      });
      // daily update
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getDailyUpdateStat/', qry).then(function (response) {
        _this12.dailyUpdate = response.data;
      });
      // asset
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getAssetsForAMCDue/', qry).then(function (response) {
        _this12.assets = response.data;
      });
      // incidents
      qry.params.incident_status = 'Open';
      qry.params.as_on = qry.params.stat_dt;
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getIncidentsByCommId/', qry).then(function (response) {
        _this12.incidents = response.data;
      });
    },
    loadListOfPeopleLiked: function loadListOfPeopleLiked(curPost) {
      var _this13 = this;

      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          post_id: curPost.post_id
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getListOfPeopleLiked/', qry).then(function (response) {
        _this13.totalLikes = response.data;
      }).catch(function (err) {
        _this13.msg(err.response.data);
      });
    },
    loadListOfPeopleCommented: function loadListOfPeopleCommented(curPost) {
      var _this14 = this;

      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          post_id: curPost.post_id
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getListOfPeopleCommented/', qry).then(function (response) {
        _this14.totalComment = response.data;
      }).catch(function (err) {
        _this14.msg(err.response.data);
      });
    },
    loadListOfPeoplePinned: function loadListOfPeoplePinned(curPost) {
      var _this15 = this;

      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          post_id: curPost.post_id
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getListOfPeoplePinned/', qry).then(function (response) {
        _this15.totalPinned = response.data;
      }).catch(function (err) {
        _this15.msg(err.response.data);
      });
    }
  }
});

/***/ }),

/***/ 825:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.config.IS_USER_ACTIVE) ? _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "info text-xs-center",
    attrs: {
      "value": "true"
    }
  }, [_vm._v("\n              Access is currently denied for your account\n              "), _c('br'), _c('br'), _vm._v("\n              Please contact your community admin if you did not expect to see this message.\n            ")])], 1)], 1)], 1)], 1) : (_vm.config.IS_USER_ACTIVE && _vm.config.ALL_UNITS.findIndex(function (rec) { return rec.rel_status !== 'Linked'; }) >= 0) ? _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.config.ALL_UNITS.filter(function (rec) { return rec.rel_status !== 'Linked'; })), function(unit, i) {
    return _c('span', {
      key: i,
      staticClass: "text-xs-center",
      attrs: {
        "color": "info",
        "value": "true"
      }
    }, [(unit.rel_status === 'Pending Approval') ? _c('v-alert', [_vm._v("\n                Your joining request for "), _c('span', {
      staticClass: "subheading yellow--text"
    }, [_vm._v(_vm._s((unit.block_nm ? (unit.block_nm + ' ' + unit.unit_no + ' in ') : '') + _vm.config.COMM_NAME))]), _vm._v(" is yet to be approved by your community admin.\n                "), _c('br'), _c('br'), _vm._v("\n                It may take few hours to process your request and you will be notified as soon as it is done.\n                "), _c('div', [_c('v-btn', {
      staticClass: "mb-0",
      attrs: {
        "flat": "",
        "color": "accent"
      },
      on: {
        "click": _vm.logout
      }
    }, [_vm._v("Logout")])], 1)]) : (unit.rel_status === 'Rejected') ? _c('v-alert', [_vm._v("\n                Your joining request for "), _c('span', {
      staticClass: "yellow--text"
    }, [_vm._v(_vm._s(unit.block_nm + ' ' + unit.unit_no))]), _vm._v(" was rejected with below reason.\n                "), _c('div', {
      staticClass: "text-xs-center white--text mt-2"
    }, [_vm._v("\n                  \"" + _vm._s(unit.rej_reason) + "\"\n                ")]), _vm._v(" "), _c('div', [_c('v-btn', {
      staticClass: "mb-0",
      attrs: {
        "flat": "",
        "color": "accent"
      },
      on: {
        "click": function($event) {
          return _vm.cancelReq(unit)
        }
      }
    }, [_vm._v("Cancel & Sign-up again")])], 1)]) : (unit.rel_status === 'Delinked' && _vm.config.ALL_UNITS.length === 1) ? _c('v-alert', [_vm._v("\n                You are currently delinked from "), _c('span', {
      staticClass: "yellow--text"
    }, [_vm._v(_vm._s((unit.block_nm ? (unit.block_nm + ' ' + unit.unit_no + ' in ') : '') + _vm.config.COMM_NAME))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Please contact your community admin if you did not expect to see this message.\n                "), _c('div', [_c('v-btn', {
      staticClass: "mb-0",
      attrs: {
        "flat": "",
        "color": "accent"
      },
      on: {
        "click": _vm.logout
      }
    }, [_vm._v("Logout")])], 1)]) : _vm._e()], 1)
  }), 0)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.config.IS_USER_ACTIVE && _vm.config.UNITS.findIndex(function (rec) { return rec.rel_status === 'Linked'; }) >= 0) ? _c('div', [_c('v-container', {
    staticClass: "pa-2",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.joinReq.length) ? _c('v-flex', {
    staticClass: "pb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": {
        path: (_vm.config.IS_ADMIN ? '/users' : '/profile/join')
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pa-2 subheading primary lighten-2 white--text"
  }, [_vm._v("\n                Joining Requests\n              ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.joinReq.length + ' request' + (_vm.joinReq.length > 1 ? 's' : '')) + " pending for your review!")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isCommSetupPend) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mb-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 subheading primary lighten-2 white--text"
  }, [_vm._v("\n            What's next?\n          ")]), _vm._v(" "), _c('v-img', {
    attrs: {
      "src": _vm.config.STATIC_FILES_DIR + '/img/others/guard_setup.png',
      "aspect-ratio": 5
    }
  }), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "subheading pb-2"
  }, [_c('strong', [(_vm.commSetupScore.setup_score.corScore <= _vm.commSetupScore.setup_score.corScoreBase) ? _c('span', [_vm._v("Almost everything is setup for your community. You are just few steps away!")]) : _c('span', [_vm._v("I guess you are not making use of all Smartility features. Complete remaining setup and enjoy them all!")])])]), _vm._v(" "), _c('ul', [(_vm.commSetupScore.setup_score.corScore <= _vm.commSetupScore.setup_score.corScoreBase) ? _c('li', [_vm._v("\n                Onboard your residents by "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.dlgHowToResDir = true
      }
    }
  }, [_vm._v("uploading resident directory")])]) : _vm._e(), _vm._v(" "), (_vm.commSetupScore.setup_score.vmScore <= _vm.commSetupScore.setup_score.vmScoreBase) ? _c('li', [_vm._v("\n                Download and install app in your "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.dlgHowToSecGaurd = true
      }
    }
  }, [_vm._v("security guard device for managing visitors")])]) : _vm._e()])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center pt-1 grey lighten-4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Setup Completion: "), _c('span', {
    staticClass: "display-1"
  }, [_vm._v(_vm._s(_vm.commSetupScore.setup_score.avgScore) + "%")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgCommSetup = true
      }
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "accent--text"
  }, [_vm._v("\n                  Core "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('span', [_vm._v("Module")]) : _vm._e()]), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "value": _vm.commSetupScore.setup_score.corScore,
      "height": "20",
      "color": "accent"
    }
  }, [_vm._v(_vm._s(_vm.commSetupScore.setup_score.corScore) + "%")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "accent--text"
  }, [_vm._v("\n                  Visitor "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('span', [_vm._v("Module")]) : _vm._e()]), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "value": _vm.commSetupScore.subscription.visitor_module ? _vm.commSetupScore.setup_score.vmScore : 0,
      "height": "20",
      "color": "accent"
    }
  }, [_vm._v(_vm._s(_vm.commSetupScore.subscription.visitor_module ? _vm.commSetupScore.setup_score.vmScore + '%' : 'Disabled'))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "accent--text"
  }, [_vm._v("\n                  Accounting "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('span', [_vm._v("Module")]) : _vm._e()]), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "value": _vm.commSetupScore.subscription.accounts_module ? _vm.commSetupScore.setup_score.acScore : 0,
      "height": "20",
      "color": "accent"
    }
  }, [_vm._v(_vm._s(_vm.commSetupScore.subscription.accounts_module ? _vm.commSetupScore.setup_score.acScore + '%' : 'Disabled'))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "accent--text"
  }, [_vm._v("\n                  Facility "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('span', [_vm._v("Module")]) : _vm._e()]), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "value": _vm.commSetupScore.subscription.facility_module ? _vm.commSetupScore.setup_score.fmScore : 0,
      "height": "20",
      "color": "accent"
    }
  }, [_vm._v(_vm._s(_vm.commSetupScore.subscription.facility_module ? _vm.commSetupScore.setup_score.fmScore + '%' : 'Disabled'))])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isMobAdminUser) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mb-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 subheading primary lighten-2 white--text"
  }, [_vm._v("\n            Welcome to Smartility Admin!\n          ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-1"
  }, [_vm._v("\n            Do you know, you can access this admin app in your mobile phone as well?\n            "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_vm._v("\n                Android\n                "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://play.google.com/store/apps/details?id=in.smartility.app&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
    }
  }, [_c('img', {
    attrs: {
      "width": "150",
      "alt": "Get it on Google Play",
      "src": "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
    }
  })])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_vm._v("\n                iPhone\n                "), _c('div', {
    staticClass: "pa-2"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.dlgHowToiPhone = true
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "Install web app",
      "width": "140",
      "src": _vm.config.STATIC_FILES_DIR + '/img/others/pwa_app.png'
    }
  })])])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.config.IS_OTHER_USER) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 text-xs-center primary lighten-2 white--text",
    attrs: {
      "to": {
        path: '/complaints'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("headset_mic")]), _vm._v("Complaints\n          ")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-2 pt-0 pb-1"
  }, [_vm._v("\n            " + _vm._s(_vm.totMine) + "\n            "), _c('v-btn', {
    staticClass: "primary lighten-2",
    staticStyle: {
      "position": "absolute",
      "bottom": "1px",
      "right": "1px",
      "border": "3px solid"
    },
    attrs: {
      "fab": "",
      "small": "",
      "to": {
        path: '/complaints/create'
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("add")])], 1)], 1)], 1)], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 text-xs-center primary lighten-2 white--text",
    attrs: {
      "to": {
        path: '/complaints'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("headset_mic")]), _vm._v("Complaints\n          ")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "subheading"
  }, [_vm._v("Open")]), _vm._v(" "), _c('div', [_vm._v("\n                  " + _vm._s(_vm.totOpenComp) + "\n                ")]), _vm._v(" "), (_vm.totNewComp) ? _c('v-chip', {
    staticClass: "white caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.totNewComp + ' new'))]) : _vm._e(), _vm._v(" "), (_vm.totCritComp) ? _c('v-chip', {
    staticClass: "error white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.totCritComp + ' critical'))]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "subheading"
  }, [_vm._v("Assigend to me")]), _vm._v(" "), _c('br'), _vm._v("\n                " + _vm._s(_vm.totMine) + "\n              ")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary lighten-2",
    staticStyle: {
      "position": "absolute",
      "bottom": "1px",
      "right": "1px",
      "border": "3px solid"
    },
    attrs: {
      "fab": "",
      "small": "",
      "to": {
        path: '/complaints/create'
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("add")])], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.config.IS_OTHER_USER) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    class: 'display-1 text-xs-center white--text ' + (_vm.visitorList.detail && _vm.visitorList.detail.findIndex(function (det) { return det.visitor_status === 'Inside'; }) >= 0 ? 'success lighten-1' : 'primary lighten-2'),
    attrs: {
      "to": {
        path: '/myvisitors/today'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("transfer_within_a_station")]), _vm._v("Visitors\n          ")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-2 pt-0 pb-1"
  }, [(!_vm.visitorList.stats || !_vm.visitorList.stats.length) ? _c('span', [_vm._v("0")]) : _vm._l((_vm.visitorList.stats), function(rec, i) {
    return _c('span', {
      key: i,
      attrs: {
        "xs6": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(_vm.visitCatIcon[rec.visitor_cat] || 'person'))]), _vm._v("\n              " + _vm._s(rec.tot_rec)), (rec.is_someone_waiting) ? _c('sup', {
      staticClass: "error--text"
    }, [_vm._v("*")]) : _vm._e()], 1)
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.config.IS_OTHER_USER) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 text-xs-center primary lighten-2 white--text",
    attrs: {
      "to": {
        path: '/noticeboard'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("assignment")]), _vm._v("Notices\n          ")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-2 pt-0 pb-1"
  }, [_vm._v("\n            " + _vm._s(_vm.totNotice) + "\n            "), (_vm.totNotice) ? _c('v-chip', {
    staticClass: "white caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.notices.length + ' new'))]) : _vm._e(), _vm._v(" "), (_vm.config.IS_USER_EMPOWERED) ? _c('v-btn', {
    staticClass: "primary lighten-2",
    staticStyle: {
      "position": "absolute",
      "bottom": "1px",
      "right": "1px",
      "border": "3px solid"
    },
    attrs: {
      "fab": "",
      "small": "",
      "to": {
        path: '/noticeboard/create'
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.config.IS_OTHER_USER) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 text-xs-center primary lighten-2 white--text",
    attrs: {
      "to": {
        path: '/posts'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("dynamic_feed")]), _vm._v("Recent Posts\n          ")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-2 pt-0 pb-1"
  }, [_vm._v("\n            " + _vm._s(_vm.posts.length) + "\n            "), _c('v-btn', {
    staticClass: "primary lighten-2",
    staticStyle: {
      "position": "absolute",
      "bottom": "1px",
      "right": "1px",
      "border": "3px solid"
    },
    attrs: {
      "fab": "",
      "small": "",
      "to": {
        path: '/posts/create'
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("add")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.invoices && !_vm.config.IS_OTHER_USER) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 text-xs-center warning",
    attrs: {
      "to": {
        path: '/invpay'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("money")]), _vm._v("Invoice\n          ")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-2 pt-0 pb-1"
  }, [_vm._v("\n            " + _vm._s(_vm.handy.formatCur(_vm.invoices.tot_due)) + "\n            "), (_vm.invoices.past_due) ? _c('v-chip', {
    staticClass: "error white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.handy.formatCur(_vm.invoices.past_due) + ' past due'))]) : _vm._e(), _vm._v(" "), (_vm.invoices.due_today) ? _c('v-chip', {
    staticClass: "warning white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.handy.formatCur(_vm.invoices.due_today) + ' due today'))]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tasks && !_vm.config.IS_OTHER_USER) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 text-xs-center warning",
    attrs: {
      "to": {
        path: '/task'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("group_work")]), _vm._v("Task\n          ")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-2 pt-0 pb-1"
  }, [_vm._v("\n            " + _vm._s(_vm.tasks.tot_task) + "\n            "), (_vm.tasks.past_due) ? _c('v-chip', {
    staticClass: "error white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.past_due + ' past due'))]) : _vm._e(), _vm._v(" "), (_vm.tasks.due_today) ? _c('v-chip', {
    staticClass: "warning white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.due_today + ' due today'))]) : _vm._e(), _vm._v(" "), (_vm.tasks.pend_appr) ? _c('v-chip', {
    staticClass: "white caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.pend_appr + ' for your approval'))]) : _vm._e()], 1)], 1)], 1) : (_vm.tasks) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 text-xs-center primary lighten-2 white--text",
    attrs: {
      "to": {
        path: '/task'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("group_work")]), _vm._v("Task\n          ")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_vm._v("\n            " + _vm._s(_vm.tasks ? _vm.tasks.tot_task : 0) + "\n            "), (_vm.tasks && _vm.tasks.past_due) ? _c('v-chip', {
    staticClass: "error white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.past_due + ' past due'))]) : _vm._e(), _vm._v(" "), (_vm.tasks && _vm.tasks.due_today) ? _c('v-chip', {
    staticClass: "warning white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.due_today + ' due today'))]) : _vm._e(), _vm._v(" "), (_vm.tasks && _vm.tasks.pend_appr) ? _c('v-chip', {
    staticClass: "white caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.pend_appr + ' for your approval'))]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.config.IS_OTHER_USER) ? _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 primary lighten-2"
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("engineering")]), _vm._v("Facility Management\n            "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    class: 'caption ml-0 mr-1 black--text ' + (_vm.statDay === 'yesterday' ? 'primary lighten-5' : 'primary lighten-3'),
    attrs: {
      "small": "",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadStatsForStaffDashboard('yesterday')
      }
    }
  }, [_vm._v("yesterday")]), _vm._v(" "), _c('v-chip', {
    class: 'caption ma-0 black--text ' + (_vm.statDay === 'today' ? 'primary lighten-5' : 'primary lighten-3'),
    attrs: {
      "small": "",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadStatsForStaffDashboard('today')
      }
    }
  }, [_vm._v("today")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": {
        path: '/attendance'
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-2 px-2 subheading primary darken-1 warning--text",
    staticStyle: {
      "height": "125px"
    }
  }, [_c('v-icon', {
    staticClass: "pr-2 warning--text"
  }, [_vm._v("camera_front")]), _vm._v("Attendance\n                    "), _c('div', {
    staticClass: "text-xs-center display-1 white--text"
  }, [_vm._v("\n                      " + _vm._s((_vm.attend.percent || 0) + '%')), _c('br'), _vm._v(" "), (_vm.attend.tot_pend) ? _c('v-chip', {
    staticClass: "red white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.attend.tot_pend + ' pending'))]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text"
  }, [_c('v-icon', {
    staticClass: "pr-2 warning--text"
  }, [_vm._v("today")]), _vm._v("Daily Update\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showDateList = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "to": {
        path: '/dailyupdate'
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-2 px-2 subheading primary darken-1 warning--text",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('div', {
    staticClass: "text-xs-center display-1 white--text"
  }, [_vm._v("\n                      " + _vm._s(_vm.dailyUpdate.c_date ? (_vm.dailyUpdate.is_sub_app || _vm.dailyUpdate.is_app ? 'Done' : 'Draft') : 'Pending') + " "), _c('br'), _vm._v(" "), (_vm.dailyUpdate.tot_pend) ? _c('v-chip', {
    staticClass: "red white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.dailyUpdate.tot_pend + ' days pending'))]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "to": {
        path: '/inventory'
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-2 px-2 subheading primary darken-1 warning--text",
    staticStyle: {
      "height": "125px"
    }
  }, [_c('v-icon', {
    staticClass: "pr-2 warning--text"
  }, [_vm._v("category")]), _vm._v("Assets\n                    "), _c('div', {
    staticClass: "text-xs-center display-1 white--text"
  }, [(_vm.assets.amc_past_due) ? _c('span', [_vm._v(_vm._s(_vm.assets.amc_past_due) + " "), _c('span', {
    staticClass: "body-1 red--text"
  }, [_vm._v("AMC past due")]), _c('br')]) : _vm._e(), _vm._v("\n                      " + _vm._s(_vm.assets.amc_due_soon) + " "), _c('span', {
    class: 'body-1 ' + (_vm.assets.amc_due_soon ? 'red--text' : '')
  }, [_vm._v("AMC due soon")]), _vm._v(" "), (_vm.assets.tot_outside) ? _c('v-chip', {
    staticClass: "white caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.assets.tot_outside + ' out for service'))]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "to": {
        path: '/incidents'
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-2 px-2 subheading primary darken-1 warning--text",
    staticStyle: {
      "height": "125px"
    }
  }, [_c('v-icon', {
    staticClass: "pr-2 warning--text"
  }, [_vm._v("report_problem")]), _vm._v("Incidents\n                    "), _c('div', {
    staticClass: "text-xs-center display-1 white--text"
  }, [_vm._v("\n                      " + _vm._s(_vm.incidents.length || 0) + "\n                    ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.config.IS_OTHER_USER || _vm.posts.length) ? _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 subheading primary lighten-2 white--text"
  }, [_vm._v("\n            Trending\n          ")]), _vm._v(" "), (!_vm.posts.length) ? _c('v-card-text', {
    staticClass: "pa-2"
  }, [_vm._v("\n            Hm, no discussions yet. Break the silence, post something interesting!\n            "), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "to": {
        path: '/posts'
      },
      "icon": "",
      "small": "",
      "flat": ""
    }
  }, [_vm._v("Go")])], 1) : _c('v-card-text', {
    staticClass: "pa-1"
  }, _vm._l((_vm.posts), function(post, i) {
    return (post.post_status !== 'Recalled' && post.post_status !== 'Disabled' && post.post_status !== 'Rejected') ? _c('div', {
      key: i
    }, [(post.post_status !== 'Draft' || (post.post_status === 'Draft' && _vm.config.IS_ADMIN)) ? _c('v-card', {
      attrs: {
        "flat": "",
        "to": {
          path: '/posts/' + (post.post_status === 'Draft' ? '2_' : '0_') + post.post_id
        }
      }
    }, [_c('v-card-text', {
      staticClass: "pa-1"
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": "",
        "sm1": ""
      }
    }, [_c('v-avatar', {
      staticClass: "ml-2",
      attrs: {
        "slot": "activator",
        "size": "48px"
      },
      slot: "activator"
    }, [_c('img', {
      attrs: {
        "src": _vm.config.FILE_URL(post.avatar_url),
        "alt": ""
      }
    })])], 1), _vm._v(" "), _c('v-flex', {
      class: _vm.$vuetify.breakpoint.sm ? 'ml-2' : '',
      attrs: {
        "xs9": "",
        "sm11": ""
      }
    }, [_c('div', {
      staticClass: "subheading"
    }, [_vm._v(_vm._s(post.post_title) + "\n                        "), (post.tagged_by == _vm.config.USER_ID) ? _c('span', {
      staticStyle: {
        "position": "absolute",
        "top": "0px",
        "right": "5px"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "yellow"
      }
    }, [_vm._v("star_border")])], 1) : _vm._e()]), _vm._v(" "), (post.post_status === 'Draft') ? _c('div', {
      staticClass: "pa-1 red lighten-2 white--text caption",
      staticStyle: {
        "position": "absolute",
        "top": "5px",
        "right": "0px"
      }
    }, [_vm._v("\n                        Pending for approval\n                      ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "primary--text"
    }, [_vm._v(" " + _vm._s(post.cust_name + ' (' + (post.block_nm ? (post.block_nm + ',' + post.unit_no) : post.role_name) + ')') + " ")]), _vm._v(" "), _c('span', {
      staticClass: "grey--text"
    }, [_vm._v(" " + _vm._s(' - ' + _vm.handy.html2text(post.post_text).substring(0, 35) + '...') + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "caption grey--text mt-2"
    }, [_c('span', {
      staticClass: "mr-2",
      domProps: {
        "innerHTML": _vm._s(_vm.handy.formatDateTime(post.post_dt) + (post.edited_dt ? '.' : (_vm.handy.formatDateTime(post.post_dt).length > 10 ? '<br/>' : '')))
      }
    }), _vm._v(" "), (post.edited_dt) ? _c('span', {
      staticClass: "mr-2 black--text"
    }, [_vm._v("Edited."), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "caption info--text"
    }, [_c('v-tooltip', {
      attrs: {
        "top": "",
        "disabled": post.likes === 0
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('span', _vm._g({
            staticClass: "mr-2",
            on: {
              "mouseover": function($event) {
                return _vm.loadListOfPeopleLiked(post)
              }
            }
          }, on), [_vm._v(_vm._s(post.likes) + " Likes")])]
        }
      }], null, true)
    }, [_vm._v(" "), _vm._l((_vm.totalLikes), function(likes, i) {
      return _c('span', {
        staticClass: "caption"
      }, [_vm._v(_vm._s(likes.cust_name + ' ' + '(' + (likes.block_nm ? (likes.block_nm + ',' + likes.unit_no) : likes.role_name) + ') ')), _c('br')])
    })], 2), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "top": "",
        "disabled": post.comments === 0
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('span', _vm._g({
            staticClass: "mr-2",
            on: {
              "mouseover": function($event) {
                return _vm.loadListOfPeopleCommented(post)
              }
            }
          }, on), [_vm._v(_vm._s(post.comments) + " Comments")])]
        }
      }], null, true)
    }, [_vm._v(" "), _vm._l((_vm.totalComment), function(comment, i) {
      return _c('span', {
        staticClass: "caption"
      }, [_vm._v(_vm._s(comment.cust_name + ' ' + '(' + (comment.block_nm ? (comment.block_nm + ',' + comment.unit_no) : comment.role_name) + ') ')), _c('br')])
    })], 2), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "top": "",
        "disabled": post.tags === 0
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('span', _vm._g({
            on: {
              "mouseover": function($event) {
                return _vm.loadListOfPeoplePinned(post)
              }
            }
          }, on), [_vm._v(_vm._s(post.tags) + " Pinned")])]
        }
      }], null, true)
    }, [_vm._v(" "), _vm._l((_vm.totalPinned), function(pinned, i) {
      return _c('span', {
        staticClass: "caption"
      }, [_vm._v(_vm._s(pinned.cust_name + ' ' + '(' + (pinned.block_nm ? (pinned.block_nm + ',' + pinned.unit_no) : pinned.role_name) + ') ')), _c('br')])
    })], 2)], 1)])], 1)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e()], 1) : _vm._e()
  }), 0)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.totDlgNotice) ? _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.dlgNotice),
      callback: function($$v) {
        _vm.dlgNotice = $$v
      },
      expression: "dlgNotice"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-badge', {
    attrs: {
      "color": "info",
      "right": ""
    }
  }, [(_vm.notices[_vm.totDlgNotice - 1].is_ad) ? _c('span', {
    staticClass: "caption",
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v("Ad")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "title primary--text"
  }, [_vm._v("Notice: " + _vm._s(_vm.notices[_vm.totDlgNotice - 1].notice_title))])])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.handy.getEditorStyle() + _vm.notices[_vm.totDlgNotice - 1].notice_text)
    }
  })]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-1"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.ackNotice(false)
      }
    }
  }, [_vm._v("Remind Me Later")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent",
      "disabled": _vm.beingSaved
    },
    nativeOn: {
      "click": function($event) {
        return _vm.ackNotice(true)
      }
    }
  }, [_vm._v("Got It")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.dlgHowToResDir),
      callback: function($$v) {
        _vm.dlgHowToResDir = $$v
      },
      expression: "dlgHowToResDir"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.config.STATIC_FILES_DIR + '/img/others/resident_dir_setup.png',
      "aspect-ratio": _vm.$vuetify.breakpoint.smAndUp ? '1.31' : '1.1'
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "title pb-1"
  }, [_vm._v("\n          Why to upload resident directory?\n        ")]), _vm._v(" "), _c('v-card-text', [_c('ul', [_c('li', [_vm._v("\n              To set up list of houses in your community along with resident contact details\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              It also sends out an invite to all your residents with detailed steps to join this community\n            ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgHowToResDir = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent",
      "to": {
        path: '/residents'
      }
    }
  }, [_c('v-icon', [_vm._v("file_upload")]), _vm._v("Go to upload")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.dlgHowToSecGaurd),
      callback: function($$v) {
        _vm.dlgHowToSecGaurd = $$v
      },
      expression: "dlgHowToSecGaurd"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.config.STATIC_FILES_DIR + '/img/others/guard_setup.png',
      "aspect-ratio": _vm.$vuetify.breakpoint.smAndUp ? '1.55' : '1.2'
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "title pb-1"
  }, [_vm._v("\n          Security guard device\n        ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          An Android phone which needs to be setup and handed over to security guard at gate for managing the visitors.\n          "), _c('ul', {
    staticClass: "mt-2"
  }, [_c('li', [_vm._v("\n              A budget Android phone with 4G/WiFi connectivity\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Download the "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=in.smartility.app",
      "target": "_blank"
    }
  }, [_vm._v("Smartility Admin")]), _vm._v(" app from Google playstore and install it\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              While joining your community, let your guard choose the role as \"Security\"\n            ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgHowToSecGaurd = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.dlgCommSetup),
      callback: function($$v) {
        _vm.dlgCommSetup = $$v
      },
      expression: "dlgCommSetup"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-1"
  }, [_vm._v("\n          Community setup completion\n        ")]), _vm._v(" "), _c('v-card-text', [_c('v-expansion-panel', [_c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "subheading primary--text"
        }, [_c('strong', [_vm._v("Core Module " + _vm._s(_vm.commSetupScore.setup_score.corScore) + "%")])])]
      },
      proxy: true
    }], null, false, 1746539645)
  }, [_vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('ul', [_c('li', [_vm._v("\n                      Default settings "), _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('li', [_vm._v("\n                      Minimum 10 residents onboarded\n                      "), (_vm.commSetupScore.setup_score.totUnit >= 10) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('span', [_c('v-icon', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("pending_actions")]), _c('br'), _vm._v(" "), _c('v-div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Go to Community > Resident Directory. Upload the list of residents")])], 1)], 1), _vm._v(" "), _c('li', [_vm._v("\n                      Minimum 10 users using the app\n                      "), (_vm.commSetupScore.setup_score.totUser >= 10) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('span', [_c('v-icon', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("pending_actions")]), _c('br'), _vm._v(" "), _c('v-div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Go to Community > Noticeboard. Publish a notice to encourage the residents to use the app.")])], 1)], 1), _vm._v(" "), _c('li', [_vm._v("\n                      Minimum 3 admin users\n                      "), (_vm.commSetupScore.setup_score.totAdmin >= 3) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('span', [_c('v-icon', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("pending_actions")]), _c('br'), _vm._v(" "), _c('v-div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Go to Admin's Corner > Users. Make appropriate users as admin.")])], 1)], 1)])])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "subheading primary--text"
        }, [_c('strong', [_vm._v("Visitor Module " + _vm._s(_vm.commSetupScore.setup_score.vmScore) + "%")])])]
      },
      proxy: true
    }], null, false, 2024308911)
  }, [_vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('ul', [_c('li', [_vm._v("\n                      Default settings "), _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('li', [_vm._v("\n                      Security guard post\n                      "), (_vm.commSetupScore.setup_score.totSecPost >= 1) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('span', [_c('v-icon', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("pending_actions")]), _c('br')], 1)], 1), _vm._v(" "), _c('li', [_vm._v("\n                      Minimum 1 security guard onboarded\n                      "), (_vm.commSetupScore.setup_score.totSecUser >= 1) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('span', [_c('v-icon', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("pending_actions")]), _c('br'), _vm._v(" "), _c('v-div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Download and install Smartility Admin app. Guide security guard to join your community.")])], 1)], 1)])])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "subheading primary--text"
        }, [_c('strong', [_vm._v("Accounting Module " + _vm._s(_vm.commSetupScore.setup_score.acScore) + "%")])])]
      },
      proxy: true
    }], null, false, 3879318171)
  }, [_vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('ul', [_c('li', [_vm._v("\n                      Default settings "), _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('li', [_vm._v("\n                      Minimum 10 residents onboarded\n                      "), (_vm.commSetupScore.setup_score.totUnitAc >= 10) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('span', [_c('v-icon', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("pending_actions")]), _c('br'), _vm._v(" "), _c('v-div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Go to Community > Resident Directory. Upload the list of residents")])], 1)], 1), _vm._v(" "), _c('li', [_vm._v("\n                      Minimum 1 bank account configured\n                      "), (_vm.commSetupScore.setup_score.totBank >= 1) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('span', [_c('v-icon', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("pending_actions")]), _c('br'), _vm._v(" "), _c('v-div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Go to Accounts > Bank & Cash. Create a new bank account")])], 1)], 1), _vm._v(" "), _c('li', [_vm._v("\n                      Account opening balance configured\n                      "), (_vm.commSetupScore.setup_score.totOPBal >= 1 || _vm.commSetupScore.setup_score.totChargeConfig >= 1) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('span', [_c('v-icon', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("pending_actions")]), _c('br'), _vm._v(" "), _c('v-div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Go to Accounts > Account Heads. Configure opening balance")])], 1)], 1), _vm._v(" "), _c('li', [_vm._v("\n                      Maintenance charge configured\n                      "), (_vm.commSetupScore.setup_score.totChargeConfig >= 1) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('span', [_c('v-icon', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("pending_actions")]), _c('br'), _vm._v(" "), _c('v-div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Go to Accounts > Charge Config. Setup a maintenance charge to be billed")])], 1)], 1)])])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "subheading primary--text"
        }, [_c('strong', [_vm._v("Facility Module " + _vm._s(_vm.commSetupScore.setup_score.fmScore) + "%")])])]
      },
      proxy: true
    }], null, false, 3938376022)
  }, [_vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('ul', [_c('li', [_vm._v("\n                      Default settings "), _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('li', [_vm._v("\n                      Minimum 1 facility staff onboarded\n                      "), (_vm.commSetupScore.setup_score.totStaff >= 1) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('span', [_c('v-icon', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("pending_actions")]), _c('br'), _vm._v(" "), _c('v-div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Guide your facility staffs (Facility Manager/Helpdesk Executive) to join your community as staff.")])], 1)], 1)])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgCommSetup = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.dlgHowToiPhone),
      callback: function($$v) {
        _vm.dlgHowToiPhone = $$v
      },
      expression: "dlgHowToiPhone"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-1"
  }, [_vm._v("\n          How to install in iPhone?\n        ")]), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "mt-2"
  }, [_c('li', [_vm._v("\n              Open your safari browser\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Go to "), _c('a', {
    attrs: {
      "href": "https://myapp.smartility.com.my",
      "target": "_blank"
    }
  }, [_vm._v("https://myapp.smartility.com.my")])]), _vm._v(" "), _c('li', [_vm._v("\n              Tap on share icon at the bottom of your browser window\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Tap on \"Add to Home Screen\" to install the app\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "width": "85%",
      "src": _vm.config.STATIC_FILES_DIR + '/img/others/pwa_install.png'
    }
  })])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgHowToiPhone = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showDateList),
      callback: function($$v) {
        _vm.showDateList = $$v
      },
      expression: "showDateList"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-1 title grey lighten-4"
  }, [_vm._v("\n      List Of FM Daily Update Pending dates\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDateList = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.dateHeader,
      "items": _vm.dailyUpdate.dateList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.selected_date)))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.posts.length) ? _c('div', [_c('v-container', [_c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-center mt-4",
    staticStyle: {
      "opacity": "0.25"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "height": "64",
      "src": _vm.config.STATIC_FILES_DIR + '/img/logo/smartility_admin.png'
    }
  })])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/44.9a3b56bd66fd3ba70e39.js